import { useCallback, useMemo } from 'react';

import { BubblePositioner } from './BubblePositioner';
import { TopicBubble } from './TopicBubble';

type CountsShape = Record<TopicId, Array<TopicId>>;

type TopicBubblesProps = {
  topics: Topic[];
  onTopicClick: (id: TopicId) => void;
  activeTopicId: TopicId;
  counts: CountsShape;
};

type BubblePositions = { outerTop: number; outerLeft: number; innerTop: number; innerLeft: number };

function calculatePositions(count: number) {
  const pos: Array<BubblePositions> = [];
  const center = { x: 50, y: 45 };
  const innerRange = { x: 28, y: 28 };
  const offset = 10;
  const frags = 360 / count;
  for (let i = 0; i < count; i += 1) {
    const theta = (frags / 180) * i * Math.PI;
    const innerTop = center.y - Math.round(innerRange.y * Math.sin(theta));
    const innerLeft = center.x + Math.round(innerRange.x * Math.cos(theta));
    const outerTop = innerTop > center.y ? innerTop + offset : innerTop - offset;
    const outerLeft = innerLeft > center.x ? innerLeft + offset : innerLeft - offset;
    pos.push({
      outerTop,
      outerLeft,
      innerTop,
      innerLeft,
    });
  }
  return pos;
}

// function calculatePositions(count: number) {
//   const pos: Array<BubblePositions> = [];
//   const center = { x: 50, y: 50 };
//   const outerRange = { x: 40, y: 40 };
//   const innerRange = { x: 35, y: 35 };
//   const frags = 360 / count;
//   for (let i = 0; i < count; i += 1) {
//     const theta = (frags / 180) * i * Math.PI;
//     pos.push({
//       outerTop: center.y - Math.round(outerRange.y * Math.sin(theta)),
//       outerLeft: center.x + Math.round(outerRange.x * Math.cos(theta)),
//       innerTop: center.y - Math.round(innerRange.y * Math.sin(theta)),
//       innerLeft: center.x + Math.round(innerRange.x * Math.cos(theta)),
//     });
//   }
//   return pos;
// }

export function TopicBubbles({ topics, onTopicClick, activeTopicId, counts }: TopicBubblesProps) {
  const getCount = useCallback((id: TopicId) => counts[id]?.length || 0, [counts]);
  const hasActiveTopic = Boolean(activeTopicId);
  const positions = useMemo(() => calculatePositions(topics.length), [topics.length]);

  return (
    <div className="relative flex items-center justify-center w-full h-full">
      <div className="relative w-3/4 h-full" onClick={() => onTopicClick(activeTopicId)}>
        {topics.map((topic, idx) => {
          const isActive = topic.id === activeTopicId;
          const hasActiveSibling = !isActive && hasActiveTopic;
          return (
            <BubblePositioner
              key={`mainTopic-${topic.id}`}
              position={positions[idx]}
              active={isActive}
              activeSibling={hasActiveSibling}
            >
              <TopicBubble topic={topic} onClick={onTopicClick} active={isActive} count={getCount(topic.id)} />
            </BubblePositioner>
          );
        })}
      </div>
    </div>
  );
}
